import React from 'react';
import type { DecoratorFn } from '@storybook/react';
import { DEFAULT_LOCALIZATION_CONTEXT } from '../../shared/constants';

/**
 * Sets given context upon window scope.
 * @param {Object} localizationContextOverrides? - The localization context to expose.
 */
export const setWindowLocalizationContext = (localizationContextOverrides = {}) => {
    const localizationContext = {
        ...DEFAULT_LOCALIZATION_CONTEXT,
        ...localizationContextOverrides,
    };

    window.initialData = window.initialData || {};
    window.initialData.LocalizationContext = localizationContext;
};

/**
 * Wraps a given story with a predefined context.
 * @param {Object} localizationContext - The localization context to expose.
 * @return {Function}
 */
export const withLocalizationContext = (localizationContextOverrides = {}) => {
    const decorator: DecoratorFn = (Story) => {
        setWindowLocalizationContext(localizationContextOverrides);

        return <Story />;
    };

    return decorator;
};
